// @ts-ignore
var DAIBER = DAIBER || {};

DAIBER.LoginService = (function () {
    // @ts-ignore
    function LoginService(jQuery) {
        // @ts-ignore
        this._jQuery = jQuery;
    }

    // @ts-ignore
    LoginService.prototype.bindToLoginElements = function (selector, callback) {
        var self = this;

        // @ts-ignore
        this._jQuery(selector).each(function (index, element) {
            var $form = self._jQuery(element);

            // @ts-ignore
            $form.on('submit', function (event) {
                event.preventDefault();
                var element = event.currentTarget;
                // Zieht return_url aus der header.phtml
                var return_url = self._jQuery('#return_url').val();

                self.login(element.loginUsername.value, element.loginPassword.value, return_url, element.clx_csrf_token.value, element.action)
                    // @ts-ignore
                    .done(function (data, status, jqHXR) {
                        return callback(null, data, $form);
                    })
                    // @ts-ignore
                    .fail(function (error) {
                        return callback(error, null, $form);
                    });
            });
        });
    };

    // @ts-ignore
    LoginService.prototype.bindToPasswordForgotElements = function (selector, callback) {
        var self = this;

        // @ts-ignore
        this._jQuery(selector).each(function (index, element) {
            var $form = self._jQuery(element);

            // @ts-ignore
            $form.on('submit', function (event) {
                event.preventDefault();
                var element = event.currentTarget;

                self.forgotPassword(element.forgotPasswordUsername.value, element.forgotPasswordEmail.value, element.clx_csrf_token.value, element.action)
                    // @ts-ignore
                    .done(function (data, status, jqHXR) {
                        return callback(null, data, $form);
                    })
                    // @ts-ignore
                    .fail(function (error) {
                        return callback(error, null, $form);
                    });
            });
        });
    };

    // @ts-ignore
    LoginService.prototype.login = function (username, password, return_url, csrfToken, target) {
        // ID/PW-Array für API-Methode
        var loginData = {
            id: username,
            password: password,
        };

        return (
            this._jQuery
                .ajax({
                    url: target,
                    method: 'POST',
                    data: {
                        username: username,
                        password: password,
                        clx_csrf_token: csrfToken,
                        'return-url': return_url,
                    },
                    credentials: 'same-origin',
                })
                // @ts-ignore
                .done(function (data, status, jqHXR) {
                    // Speicherung Credentials
                    // @ts-ignore
                    if (window.PasswordCredential && window.PublicKeyCredential && data.success) {
                        // @ts-ignore
                        var credential = new PasswordCredential(loginData);
                        navigator.credentials.store(credential);
                    }
                })
        );
    };

    // @ts-ignore
    LoginService.prototype.forgotPassword = function (username, email, csrfToken, target) {
        return this._jQuery.post(target, {
            username: username,
            email: email,
            clx_csrf_token: csrfToken,
        });
    };

    return LoginService;
})();

var loginService;
// @ts-ignore
$().ready(function () {
    // @ts-ignore
    loginService = new DAIBER.LoginService($);

    // @ts-ignore
    loginService.bindToLoginElements('#loginFormMain, #loginFormWatchlist', function (error, data, jQueryElement) {
        if (error === null && data.success === true) {
            if (data.redirect) {
                window.location = data.redirect;
            } else {
                window.location.reload();
            }
        } else {
            const messageType = data.type || 'error';
            const loginContainer = jQueryElement.closest('.login');
            const errorContainer = loginContainer.get()[0].querySelector('.show_login_message');
            errorContainer.classList.remove('error_msg');
            errorContainer.classList.remove('notice_msg');
            if (messageType === 'error') {
                errorContainer.classList.add('error_msg');
                loginContainer.find('.login_field').addClass('field_with_errors');
                data.message = '<b>' + data.message + '</b>';
            }
            if (messageType === 'notice') {
                errorContainer.classList.add('notice_msg');
            }
            errorContainer.classList.add('active');
            errorContainer.innerHTML = '<strong>' + data.message + '</strong>';
        }
    });

    // @ts-ignore
    loginService.bindToPasswordForgotElements('.forgot_password_form', function (error, data, jQueryElement) {
        // @ts-ignore
        $context = jQueryElement.closest('.login').find('.remember_form');
        if (error === null && data.success === true) {
            // @ts-ignore
            $context.find('.show_login_message').removeClass('error_msg').removeClass('notice_msg').addClass('success_msg');
            // @ts-ignore
            $context.find('.login_field').removeClass('field_with_errors');
        } else {
            // @ts-ignore
            $context.find('.show_login_message').removeClass('success_msg').addClass('error_msg');
            // @ts-ignore
            $context.find('.login_field').addClass('field_with_errors');
        }

        // @ts-ignore
        $context
            .find('.show_login_message')
            .addClass('active')
            .html('<strong>' + data.message + '</strong>');
    });

    // @ts-ignore
    $(document).on('click', '.trigger_login', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        //DAIB2-1757
        {
            // @ts-ignore
            var returnUrl = $(this).data('returnurl');

            if ('undefined' !== typeof returnUrl) {
                var node = document.createElement('input');
                node.setAttribute('type', 'hidden');
                node.setAttribute('id', 'return_url');
                node.setAttribute('name', 'return_url');
                node.setAttribute('value', returnUrl);
                // @ts-ignore
                document.getElementById('loginFormMain').appendChild(node);
            }
        }

        // @ts-ignore
        var element = viewport === 'mobile' ? document.querySelector('.nav-trigger') : document.querySelector('.h_login_link');
        // @ts-ignore
        element.click();
    });

    // watchlist: switch to forgot password
    if (document.querySelector('.query_top .login_form .forgot_password')) {
        // @ts-ignore
        document.querySelector('.query_top .login_form .forgot_password').addEventListener('click', function (e) {
            e.preventDefault();

            // reset error messages on forgot password form
            // @ts-ignore
            $('.show_login_message').removeClass('active');
            // @ts-ignore
            $('.forgot_password_form').find('.login_field').removeClass('field_with_errors');

            // @ts-ignore
            document.querySelector('.query_top .login_form').classList.remove('active');
            // @ts-ignore
            document.querySelector('.query_top .remember_form').classList.add('active');
        });
    }

    // watchlist: switch back to login form
    if (document.querySelector('.query_top .remember_form .back_to_login')) {
        // @ts-ignore
        document.querySelector('.query_top .remember_form .back_to_login').addEventListener('click', function (e) {
            e.preventDefault();

            // reset error messages on login form
            // @ts-ignore
            $('.show_login_message').removeClass('active');
            // @ts-ignore
            $('#loginFormWatchlist').find('.login_field').removeClass('field_with_errors');

            // @ts-ignore
            document.querySelector('.query_top .login_form').classList.add('active');
            // @ts-ignore
            document.querySelector('.query_top .remember_form').classList.remove('active');
        });
    }
});
